import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const CirclePercent = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 44.269531 25 C 44.269531 14.355469 35.644531 5.730469 25 5.730469 C 14.355469 5.730469 5.730469 14.355469 5.730469 25 C 5.730469 35.644531 14.355469 44.269531 25 44.269531 C 35.644531 44.269531 44.269531 35.644531 44.269531 25 Z M 30.144531 17.644531 C 30.753906 17.035156 31.746094 17.035156 32.355469 17.644531 C 32.964844 18.253906 32.964844 19.246094 32.355469 19.855469 L 19.855469 32.355469 C 19.246094 32.964844 18.253906 32.964844 17.644531 32.355469 C 17.035156 31.746094 17.035156 30.753906 17.644531 30.144531 Z M 31.269531 29.6875 L 31.429688 29.695312 C 32.21875 29.777344 32.832031 30.441406 32.832031 31.25 C 32.832031 32.058594 32.21875 32.722656 31.429688 32.804688 L 31.269531 32.8125 L 31.25 32.8125 C 30.386719 32.8125 29.6875 32.113281 29.6875 31.25 C 29.6875 30.386719 30.386719 29.6875 31.25 29.6875 Z M 18.769531 17.1875 L 18.929688 17.195312 C 19.71875 17.277344 20.332031 17.941406 20.332031 18.75 C 20.332031 19.558594 19.71875 20.222656 18.929688 20.304688 L 18.769531 20.3125 L 18.75 20.3125 C 17.886719 20.3125 17.1875 19.613281 17.1875 18.75 C 17.1875 17.886719 17.886719 17.1875 18.75 17.1875 Z M 47.394531 25 C 47.394531 37.367188 37.367188 47.394531 25 47.394531 C 12.632812 47.394531 2.605469 37.367188 2.605469 25 C 2.605469 12.632812 12.632812 2.605469 25 2.605469 C 37.367188 2.605469 47.394531 12.632812 47.394531 25 Z M 47.394531 25 "
        fill={color}
      />
    </svg>
  )
}
